import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activePaymentMethod: null,
  // Method type asked to be opened from outside the payment tabs (e.g. the retry limit modal).
  requestedPaymentMethod: null,
  buttonError: false,
  buttonLoading: false,
  paymentMethodInfo: null,
  popUpWindowIframeForUpiIntent: undefined
};

export const paymentButtonSlice = createSlice({
  name: "paymentButton",
  initialState,
  reducers: {
    changeActivePaymentMethod(state, action) {
      state.activePaymentMethod = action.payload;
      state.buttonError = false;
      state.buttonLoading = false;
      state.paymentMethodInfo = null;
    },
    requestPaymentMethod(state, action) {
      state.requestedPaymentMethod = action.payload;
    },
    changePaymentMethodInfo(state, action) {
      state.paymentMethodInfo = action.payload;
    },
    toggleButtonError(state, action) {
      state.buttonError = action.payload;
    },
    toggleButtonLoading(state, action) {
      state.buttonLoading = action.payload;
    },
    setPopUpWindowIframeForUpiIntent(state, action) {
      state.popUpWindowIframeForUpiIntent = action.payload;
    },
  },
});
export const {
  changeActivePaymentMethod,
  requestPaymentMethod,
  changePaymentMethodInfo,
  toggleButtonLoading,
  toggleButtonError,
  setPopUpWindowIframeForUpiIntent
} = paymentButtonSlice.actions;

export const selectActivePaymentMethod = (state) =>
  state?.paymentButton?.activePaymentMethod;

export const selectButtonError = (state) => state?.paymentButton?.buttonError;

export const selectButtonLoading = (state) =>
  state?.paymentButton?.buttonLoading;
export const selectPopWindowIframeUpiIntent = (state) =>
  state?.paymentButton?.popUpWindowIframeForUpiIntent;

export const selectPaymentMethodInfo = (state) =>
  state?.paymentButton?.paymentMethodInfo;

export default paymentButtonSlice.reducer;
